import React from "react";

function toEmbed(url) {
  if (!url) return null;
  try {
    if (url.includes("youtube.com") || url.includes("youtu.be")) {
      let id = "";
      if (url.includes("youtu.be/")) id = url.split("youtu.be/")[1].split(/[?&]/)[0];
      else if (url.includes("watch?v=")) id = url.split("watch?v=")[1].split(/[?&]/)[0];
      else if (url.includes("/embed/")) id = url.split("/embed/")[1].split(/[?&]/)[0];
      else if (url.includes("/shorts/")) id = url.split("/shorts/")[1].split(/[?&]/)[0];
      return id ? { type: "iframe", src: `https://www.youtube.com/embed/${id}` } : null;
    }
    if (url.includes("vimeo.com")) {
      const id = url.split("vimeo.com/")[1].split(/[?&/]/)[0];
      return id ? { type: "iframe", src: `https://player.vimeo.com/video/${id}` } : null;
    }
    return { type: "video", src: url };
  } catch {
    return { type: "video", src: url };
  }
}

export function VideoEmbed({ url, className = "" }) {
  const e = toEmbed(url);
  if (!e) return null;
  return (
    <div data-testid="video-embed" className={`relative w-full overflow-hidden rounded-2xl border border-white/10 bg-black ${className}`} style={{ aspectRatio: "16 / 9" }}>
      {e.type === "iframe" ? (
        <iframe src={e.src} title="video" className="absolute inset-0 w-full h-full" frameBorder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowFullScreen />
      ) : (
        <video src={e.src} controls className="absolute inset-0 w-full h-full object-contain bg-black" />
      )}
    </div>
  );
}
